import { render, staticRenderFns } from "./success-payment.vue?vue&type=template&id=66298694&scoped=true&"
import script from "./success-payment.vue?vue&type=script&lang=js&"
export * from "./success-payment.vue?vue&type=script&lang=js&"
import style0 from "./success-payment.vue?vue&type=style&index=0&id=66298694&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66298694",
  null
  
)

export default component.exports